import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { IContact, IContactRequest } from '@ontime/types';

const API_URL = `${ApiURL()}/contact`;

class ContactService {

    async Create(input: IContactRequest): Promise<IContact> {
        const response = await axios.post<IContact>(API_URL, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

}

export default new ContactService();